// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kwnlr","comment":"styles_comment__1UfOB"};